module.exports = __webpack_public_path__ + "static/img/cont603.9cf6fad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont603.jpg
// module id = aZun
// module chunks = 0